import React from "react";
import { Container, Row, Col } from "reactstrap";
import CountUp from "react-countup";

const Counter = () => {
    return (
        <React.Fragment>
            <section className="section bg-light">
                <Container>
                    <Row>
                        <Col lg={3} md={6}>
                            <div className="counter-box mt-3">
                                <div className="counters counter_custom text-center">
                                    <CountUp
                                        end={20}
                                        duration={1}
                                        className="counter mb-0"
                                    ></CountUp>
                                    <h2 style={{ position: 'absolute', top: 35, right: 80, fontSize: '20px', lineHeight: '1', fontSize: '28px' }} >+</h2>
                                    <h6 className="fs-16 mt-3 ">Years of Experience</h6>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="counter-box mt-3">
                                <div className="counters counter_custom text-center">
                                    <CountUp
                                        end={24}
                                        duration={1}
                                        className="counter mb-0"
                                    ></CountUp>
                                    <h6 className="fs-16 mt-3">Hours Response Time</h6>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="counter-box mt-3">
                                <div className="counters counter_custom text-center">
                                    <CountUp
                                        end={1000}
                                        // decimals={2}
                                        duration={1}
                                        className="counter mb-0"
                                    ></CountUp>
                                    <h2 style={{ position: 'absolute', top: 35, right: 35, fontSize: '20px', lineHeight: '1', fontSize: '28px' }} >+</h2>
                                    <h6 className="fs-16 mt-3">Successful Placements</h6>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} md={6}>
                            <div className="counter-box mt-3">
                                <div className="counters counter_custom text-center">
                                    <CountUp
                                        end={93}
                                        duration={1}
                                        className="counter mb-0"
                                    ></CountUp>
                                    <h2 style={{ position: 'absolute', top: 35, right: 75, fontSize: '20px', lineHeight: '1', fontSize: '28px' }} >%</h2>
                                    <h6 className="fs-16 mt-3">Candidate Retention</h6>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Counter;
